module.exports = __webpack_public_path__ + "img/Rectangle 14.307c4689.png";